const fillPagesWithNumbers = (startPage, pagesSize) => {
  const pages = [];
  for (let page = startPage; page <= pagesSize; page++) {
    pages.push(page);
  }
  return pages;
};

export default fillPagesWithNumbers;
